import { useDocumentVisibility } from '@mantine/hooks'
import { useEffect, useRef } from 'react'

export const useDocumentVisibleAfterDelay = (
  callback: () => void,
  delay = 1000
) => {
  const visibility = useDocumentVisibility()
  const lastHiddenTimeRef = useRef<number | null>(null)

  useEffect(() => {
    if (visibility === 'hidden') {
      // Save when tab was hidden
      lastHiddenTimeRef.current = Date.now()
    } else if (visibility === 'visible') {
      // Check how long tab was hidden
      if (lastHiddenTimeRef.current !== null) {
        const hiddenDuration = Date.now() - lastHiddenTimeRef.current

        if (hiddenDuration >= delay) {
          callback() // Run callback if hidden long enough
        }
      }
      // Reset hidden time
      lastHiddenTimeRef.current = null
    }
  }, [visibility, delay, callback])
}
